import { Skeleton } from '@thg-commerce/gravity-elements'
import {
  mq,
  spacing,
  styled,
  Text,
  TextEntry,
  TextStyle,
  TextTransform,
} from '@thg-commerce/gravity-theme'

export const Title = styled.h2<{
  textEntry?: TextEntry
  textStyle?: TextStyle
  textTransform?: TextTransform
}>`
  ${(props) =>
    Text(props.textEntry || 'large1', props.textStyle || 'alternate')};
  text-transform: ${(props) => props.textTransform || 'none'};
  margin: ${spacing(2)} 0 ${spacing(4)};
  text-align: left;

  ${(props) => mq(props.theme.breakpointUtils.map, 'lg')} {
    margin: ${spacing(4)} 0;
  }
`

export const ListWrapper = styled.div`
  padding: 0 ${spacing(2)};
  margin-bottom: ${spacing(5)};
`
export const TextSkeleton = styled(Skeleton)`
  width: 20vw;
  min-width: 150px;
  max-height: 2rem;
  margin-bottom: ${spacing(2)};
`

export const GridContainer = styled.ul`
  display: flex;
  overflow-x: auto;
  width: 100%;
  height: inherit;
  gap: ${spacing(2)};
  > * {
    min-width: 170px;
    width: 20%;
    min-height: 350px;
    max-width: 300px;
    max-height: 560px;
  }
`
